import React from 'react';
import ProductFallbackImage from './ProductFallbackImage';
import ProductImagePlaceholder from './ProductImagePlaceholder';
import ProductMediaGrid from './ProductMediaGrid';
import useProductMediaGallery from './useProductMediaGallery';
import './imageForProductById.scss';

const ImageForProductById: React.FC = () => {
  const {
    imgStatus,
    hasProductImages,
    hasMaterialRows,
    materialMediaItems,
    loadedImages,
    cursorPosition,
    zoomedImageId,
    handleImageLoad,
    handleImageError,
    handlePointerMove,
    handleImageClick,
  } = useProductMediaGallery();

  return (
    <div className="product-detail-image-container">
      {imgStatus === 'loading' && <ProductImagePlaceholder loading />}
      {imgStatus === 'succeeded' && hasMaterialRows && !hasProductImages && <ProductFallbackImage />}
      {imgStatus === 'succeeded' && hasProductImages && (
        <ProductMediaGrid
          items={materialMediaItems}
          loadedImages={loadedImages}
          cursorPosition={cursorPosition}
          zoomedImageId={zoomedImageId}
          onImageLoad={handleImageLoad}
          onImageError={handleImageError}
          onPointerMove={handlePointerMove}
          onImageClick={handleImageClick}
        />
      )}
      {imgStatus === 'failed' && (
        <ProductImagePlaceholder>
          <p>No images available</p>
        </ProductImagePlaceholder>
      )}
    </div>
  );
};

export default React.memo(ImageForProductById);
